type ISettings = {
    siteUrl: string;
    shopName: string
    instagramName?: string;
    telegramName?: string;
}

export const Settings: ISettings = {
    siteUrl: 'https://jeanser-ua.github.io',
    shopName: 'Jeanser',
    instagramName: 'jeanser.ua',
    telegramName: 'jeanser_ua'
};